import { createStyles, makeStyles, Theme, Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import React, { useCallback, useState } from 'react';

import { PlexTypography, PlexTypographyProps } from './PlexTypography';

interface Props {
  tooltip?: string;
}

export const PlexTypographyEllipsed = React.memo(
  (props: Props & PlexTypographyProps): React.ReactElement => {
    const { className, tooltip, ...other } = props;
    const classes = useStyles(props);
    const [hasEllipses, setHasEllipses] = useState(false);
    const typographyRef = useCallback((node: HTMLSpanElement | null) => {
      // Note that this does not watch for dynamic resizing
      // More details at https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
      setHasEllipses(node != null && node.scrollWidth > node.clientWidth);
    }, []);

    const ellipsedTypography = (
      <PlexTypography className={classNames(className, classes.ellipsedText)} ref={typographyRef} {...other} />
    );

    if (!tooltip) {
      return ellipsedTypography;
    }

    return (
      <Tooltip title={tooltip} disableHoverListener={!hasEllipses}>
        {ellipsedTypography}
      </Tooltip>
    );
  }
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ellipsedText: {
      display: 'block', // necessary for the ellipsis to work
      textOverflow: 'ellipsis', // necessary for the ellipsis to work
      overflow: 'hidden', // necessary for the ellipsis to work
      whiteSpace: 'nowrap', // necessary for the ellipsis to work
    },
  })
);
